import React from "react";
import { Grid } from "@mui/material";
import PlayerCard from "../PlayerCard/PlayerCard";
import MediaRankingListRow from "./MediaRankingListRow";
import "./MediaRankingPlayers.css";

/**
 * Grid or list layout for players on media ranking / mock draft detail pages.
 *
 * @param {object} props
 * @param {Array<{ player: object, rank: number|string, team?: object }>} props.items
 * @param {"grid"|"list"} props.viewMode
 * @param {"Rank"|"Pick"} [props.rankLabel]
 */
function MediaRankingPlayers({ items, viewMode, rankLabel = "Rank" }) {
    if (!items?.length) {
        return null;
    }

    if (viewMode === "list") {
        return (
            <Grid item xs={12}>
                <div className="media-ranking-players-list" role="list">
                    {items.map((item) => (
                        <div
                            key={`${item.player?.player_id}-${item.rank}`}
                            className="media-ranking-players-list-item"
                            role="listitem"
                        >
                            <MediaRankingListRow
                                player={item.player}
                                rank={item.rank}
                                rankLabel={rankLabel}
                                team={item.team}
                            />
                        </div>
                    ))}
                </div>
            </Grid>
        );
    }

    return items.map((item) => (
        <Grid
            item
            xs={6}
            sm={6}
            md={3}
            lg={12 / 5}
            key={`${item.player?.player_id}-${item.rank}`}
        >
            <PlayerCard
                playerData={item.player}
                ranking={item.rank}
                rankTitle={rankLabel}
                nhlTeam={item.team}
                miniView={true}
            />
        </Grid>
    ));
}

export default MediaRankingPlayers;
